<!-- 最新快讯 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-10">
        <dateList-01 title="日期" :showTitle="true" :showMore="false" :yearMonthList="yearMonthList" label="DATE" titleLength="20" count="8" v-on:queryPage="zxkx_Req"/>
      </div>
      <div class="content-col col-per-90">
        <infoList title="最新快讯" label="FAST NEWS" :showTitle="true" :showMore="false" :infoBlock="infoBlock1" :infoPage="infoPage1" v-on:queryPage="zxkx_Req" titleLength="30" count="18"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ZxkxInfo from '../module/ZxkxInfo'
import InfoList from '../block/InfoList'
import DateList01 from '../block/DateList01'
export default {
  name: 'Hyzx02',
  components: {
    'infoList':InfoList,
    'dateList-01': DateList01,
  },
  data() {
    return {
      msg: '',
      infoBlock1:ZxkxInfo,
      infoPage1:{},
      yearMonthList:[],
    }
  },
  methods:{
      //最新快讯年月
      zxkxYM_Req(){
            let that=this;
            that.$dataApi.fastNewsMonth({}).then(res =>{
            console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            that.yearMonthList=res.data;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
            });
      },
      //最新快讯
      zxkx_Req(params){
            var date = new Date();
            let that=this;
            if(params.queryYear==undefined||params.queryYear==""){
              var date = new Date();
              params.queryYear=date.getFullYear();
              params.queryMonth=date.getMonth()+1;
            }
            if(this.Global.siteTabId>0){params.tag_id=this.Global.siteTabId;}
            let result={page:params};
            //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
            that.$dataApi.fastNewsLists(params).then(res =>{
            //console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            result.list= res.data.list;
            result.page.total=res.data.total;
            that.infoPage1=result;
            // console.log('结束请求Vue-axios：'+JSON.stringify(result))
            });
      },
    },
    created:function(){
      //let params={page:1,pageSize:this.pageSize,type:this.type};
      this.zxkxYM_Req();
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-90 {
  flex-grow:9;
}

.col-per-10 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Hyzx02.vue